// ==========================================================================
// Data Conversion Helpers
//
// Copyrights 2019 Wewasanad Co.,Ltd.
// ==========================================================================

/**
 * The class consists a series of data conversion into different formats.
 */
export default class Convert {
    /**
     * Convert time in seconds into timestamp format (hh:mm:ss)
     * @param seconds - Time in seconds
     * @returns {string} - Timestamp string (hh:mm:ss)
     */
    static toTimestamp(seconds) {
        let d = Number(seconds);

        let h = Math.floor(d / 3600);
        let m = Math.floor(d % 3600 / 60);
        let s = Math.floor(d % 3600 % 60);

        return ('0' + h).slice(-2) + ":" + ('0' + m).slice(-2) + ":" + ('0' + s).slice(-2);
    }
}